import {Record} from "immutable";

/*
  Records are "smart" pieces of immutable data that
  link a resource type with the api layer and context
  layer. All Records will be a instaniated with a
  Recource() function which will return a Record factory
  with the appropirate resource/context relevant methods
*/

/*
  @param name: the  name of the key for this resource in the container
  @param service: the feathers service for this resource
  @param service: the INSTANCE of the AppContainer, this should be
    the same INSTANCE for all records
  @param defaultValues: and obj literal of default keys for the resource
    like _id, name, etc
  @param methods: and obj literal of additional methods to apply
    to the Record
*/
export default (service, defaultValues, methods) => {
  class Resource extends Record({
    ...defaultValues,
    // Also tack on some standard values that all records have
    createdAt: "",
    updatedAt: "",
    __v: "",
    _id: ""
  }) {
    create(apiParams = {}) {
      if (this._id) {
        return new Error("Method create() cannot be called on a record with an _id prop already");
      }
      return service.create(this, apiParams);
      // const obj = toFeathers(this)
      // const createdResource = await service.create(obj, apiParams)
      // const mergedResource = new Resource(createdResource)
      // container.setIn([name, this._id], mergedResource)
      // return mergedResource
    }

    async update(apiParams = {}) {
      if (!this._id) {
        return new Error("Method update() must be called on a record with an _id.");
      }
      return service.update(this._id, this, apiParams);
      // const obj = toFeathers(this)
      // const updatedResource = await service.update(this._id, obj, apiParams)
      // const immutableResource = new Resource(updatedResource)
      // container.setIn([name, this._id], immutableResource)
      // return immutableResource
    }

    async patch(apiParams = {}) {
      if (!this._id) {
        return new Error("Method patch() must be called on a record with an _id.");
      }
      return service.patch(this._id, this, apiParams);
      // const obj = toFeathers(this)
      // const patchedResource = await service.patch(this._id, obj, apiParams)
      // const immutableResource = new Resource(patchedResource)
      // container.setIn([name, this._id], immutableResource)
      // return immutableResource
    }

    async remove(apiParams = {}) {
      if (!this._id) {
        return new Error("Method remove() must be called on a record with an _id.");
      }
      return service.remove(this._id, apiParams);
      // const removedResource = await service.remove(this._id, apiParams)
      // const immutableResource = new Resource(removedResource)
      // container.deleteIn([name, this._id])
      // return immutableResource
    }

    // Note this is analogous to the .get() method
    // but "get" is a reserved word for immutable.js record
    // This could really be named .reload() ?
    async fetch(apiParams = {}) {
      if (!this._id) {
        return new Error("Method fetch() must be called on a record with an _id.");
      }
      return service.get(this._id, apiParams);
      // const result = await service.get(this._id, apiParams)
      // const immutableResource = new Resource(result)
      // container.setIn([name, this._id], immutableResource)
      // return immutableResource
    }

    // Note this is static to be called on the class, not an instance
    static async find(apiParams = {}) {
      return service.find(apiParams);
      // const result = await service.find(apiParams)
      // const map = Map(result.data.map(res => [res._id, new Resource(res)]))
      // container.set(name, map)
      // return map
    }
  }

  // Add the additional methods onto the new Resource class
  if (methods) {
    Object.keys(methods).forEach(method => {
      Resource.prototype[method] = methods[method];
    });
  }

  return Resource;
};

export const toFeathers = record => {
  const obj = record.toJS();
  delete obj._id;
  return obj;
};



// WEBPACK FOOTER //
// ./src/feathers/resource.js